var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallNoAvatarD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EDE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8866 9.28137L16.0358 10.6472C17.6273 12.5348 17.4622 15.3788 15.6567 17.1845L14.6766 18.1633C14.4153 18.4251 14.3298 18.8148 14.4574 19.162C14.814 20.1368 15.724 21.3547 17.1849 22.8157C18.647 24.2779 19.8648 25.1867 20.8383 25.5447C21.1857 25.672 21.5754 25.5859 21.8368 25.3241L22.8156 24.3453C24.6211 22.5396 27.4636 22.3732 29.3537 23.9622L30.7194 25.1128C32.278 26.4245 32.4365 28.7889 31.0707 30.3925C30.3259 31.2542 29.2775 31.7955 28.1438 31.9037C23.7798 32.4915 19.2018 30.3886 14.4072 25.5936C9.61257 20.7986 7.50849 16.2189 8.09626 11.8559C8.1268 11.5145 8.19774 11.1779 8.30759 10.8533C8.56176 10.1075 9.01044 9.44306 9.60728 8.92868C11.2121 7.56416 13.575 7.72135 14.8866 9.28137Z",
    fill: "url(#paint0_linear_1975_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1975_37",
    x1: 20,
    y1: 8,
    x2: 20,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallNoAvatarD);
export default __webpack_public_path__ + "static/media/call_no_avatar_d.e5e28af9b3fab76bd14d3f9778f85362.svg";
export { ForwardRef as ReactComponent };